<template>
    <div id=app>

        <div v-if="isIdle" />

        <sct-header>

            <template v-slot:headerDatosUsuario>
                <span style="margin: 40px" v-if=" role_logged !== null && role_logged.includes('Bienvenida') ">Bienvenida(o): {{user_logged}}</span>
                <button v-if="role_logged === null" type="button" class="btn btn-default btn-sm"
                        data-toggle="modal"
                        data-target="#myModal">
                    Iniciar sesión
                </button>
                <div v-if=" role_logged !== null && (role_logged == 'undefined' || role_logged.includes('BtnCierreSesión')) " type="button" class="btn btn-default btn-sm pull-right"
                        v-on:click="logout">
                    Cerrar Sesión
                </div>
            </template>

            <template v-slot:headerMenu>
                <div style="display:flex; justify-content:space-between">
                    <div class="m-v-10">
                        <div v-if=" role_logged !== null && role_logged.includes('Background') " class="btn btn-default btn-sm"
                                v-on:click="showComponent('Background')">
                            <span class="icon-home" aria-hidden="true"></span>
                        </div>
                        <div v-if=" role_logged !== null && role_logged.includes('Servicios') " class="btn-group" role="group">
                            <div id="btnGroupVerticalDrop2" type="button" class="btn btn-sm btn-default dropdown-toggle"
                                    data-toggle="dropdown" aria-expanded="false">
                                Servicios
                                <span class="caret"></span>
                            </div>
                            <ul v-if=" role_logged !== null && role_logged.includes('ProofOfPayment') " class="dropdown-menu" role="menu" aria-labelledby="btnGroupVerticalDrop2">
                                <li><a href="#" v-on:click="showComponent('ProofOfPayment')">Comprobante de pago</a></li>
                            </ul>
                        </div>
                        <div v-if=" role_logged !== null && role_logged.includes('Gestion') " class="btn-group" role="group">
                            <div id="btnGroupVerticalDrop2" type="button" class="btn btn-sm btn-default dropdown-toggle"
                                    data-toggle="dropdown" aria-expanded="false">
                                Gestión
                                <span class="caret"></span>
                            </div>
                            <ul class="dropdown-menu" role="menu" aria-labelledby="btnGroupVerticalDrop2">
                                <li><a href="#" v-on:click="showComponent('DownloadLog')">Bitácora Descarga</a></li>
                                <li><a href="#" v-on:click="showComponent('AdminSlider')">Administrador de Carrusel</a></li>
                                <li><a href="#" v-on:click="showComponent('AdminUser')">Administrador de Accesos</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="m-v-10" v-if=" role_logged !== null && role_logged.includes('Bienvenida') ">
                        <div style="font-family: Arial;font-size: 11px;display: flex;flex-direction: column;min-width: 162px;border: 2px solid;padding: 6px;border-radius: 4px;">
                            <span><i class="glyphicon glyphicon-user" style="margin-right: 2px;"></i><b>ID</b> - {{id_logged}}</span>
                            <span><i class="glyphicon glyphicon-credit-card" style="margin-right: 2px;"></i><b>RFC</b> - {{rfc_logged}}</span>
                        </div>
                    </div>
                </div>
            </template>

        </sct-header>

        <section class="contenido">
            <component :is="selected"/>
        </section>

        <sct-footer/>

        <sct-modal-login @custom-login="login" />

    </div>
</template>

<script>

    import Vue from 'vue';
    import axios from 'axios';

    import Slider from "@/components/Slider";
    import DownloadLog from "@/components/DownloadLog";
    import ProofOfPayment from "@/components/ProofOfPayment";
    import Background from "@/components/Background";
    import AdminSlider from "@/components/AdminSlider";
    import AdminUser from "@/components/AdminUser";

    import SctFooter from "@/components/template/SctFooter";
    import SctHeader from "@/components/template/SctHeader";
    import SctModalLogin from "@/components/template/SctModalLogin"

    export default {
        name: 'App',
        components: {
            SctFooter,
            SctHeader,
            Slider,
            DownloadLog,
            ProofOfPayment,
            Background,
            AdminSlider,
            AdminUser,
            SctModalLogin
        },
        data() {
            return {
                show: false,
                mensajeErrorModal: false,
                selected: Slider,
                role_logged: localStorage.getItem('role'),
                user_logged: localStorage.getItem('name'),
                rfc_logged: localStorage.getItem('user_rfc'),
                id_logged: localStorage.getItem('user_id')
            }
        },
        mounted() {

            //En caso de que el localStorage llegue a estar nulo
            if (localStorage == null) {

                //console.log("opción 1");
                this.selected = Slider;
            }

            //Si le llega vacio el localstorage en la pantallaActual
            if (localStorage != null && localStorage.getItem('pantallaActual') == null) {

                //console.log("opción 2");
                this.selected = Slider;
                localStorage.setItem('pantallaActual', Slider)
            }

            //Para que al refrescar (F5) no se pierda la pantalla
            if(localStorage != null && localStorage != undefined 
            && localStorage.getItem('pantallaActual') != '[object Object]' 
            && localStorage.getItem('pantallaActual') != null) {

                //console.log("opción 3");
                this.selected = localStorage.getItem('pantallaActual')
            } 

            //Cuando inician sesión y enseguida dan (F5) 
            //(por algun motivo la pantalla actual es igual a Object en este escenario)
            if (localStorage != null && this.selected != null  
            && localStorage.getItem('pantallaActual') == '[object Object]' 
            && localStorage.getItem('role') != null) {

                //console.log("opción 4");
                this.selected = Background
                localStorage.setItem('pantallaActual', Background)
            }
        },
        methods: {
            login(id, rfc) {
                    
                this.role_logged = localStorage.getItem('role')
                this.user_logged = localStorage.getItem('name')
                this.rfc_logged = rfc;
                this.id_logged = id;
                this.selected = Background
                localStorage.setItem('pantallaActual', Background)
            },
            logout() {

                this.rfc_logged = null
                this.id_logged = null
                this.role_logged = null
                this.user_logged = null
                localStorage.clear()
            
                this.selected = Slider
                localStorage.setItem('pantallaActual', Slider)
            },
            refresh(username, password) {

                axios.post(Vue.prototype.$globalHost + '/login', {
                    "usuario": username,
                    "password": password
                })
                .then(response => {

                    let token = response.headers.authorization;
                    localStorage.setItem('token', token)
                    location.reload(); //refresca la pantalla
                })
                .catch(error => console.log(error))

            },
            refreshOut() {

                this.role_logged = null
                this.user_logged = null
                localStorage.clear()

                this.selected = Slider
                localStorage.setItem('pantallaActual', Slider)
                location.reload(); //refresca la pantalla
            },
            showComponent(component) {
                
                this.selected = component
                localStorage.setItem('pantallaActual', component)
            }
        }, computed: {
            isIdle() {

                return this.$store.state.idleVue.isIdle;
            }
        }, watch: {
            isIdle: {
                deep: true,
                handler: function() {

                    if (this.$store.state.idleVue.isIdle 
                    && localStorage.getItem('role') != null) {

                        console.log('Logout automatico ejecutado');
                        this.logout();
                    }
                }
            
            }
        }
    }
</script>